import axios from 'axios';
import utilsService from '@/services/utilsService.ts';

/**
 * flat rate work API Service.
 * Communication interface for the FlatRateWork REST API.
 */
export default {
  getFlatRateWorkByGid,
};

const flatRateWorkBaseUrl = `${import.meta.env.VITE_TIME_REPORT_API_BASE_URL}/flat_rate_works`;

/**
 * Return the flat rate work filtered by user Gid.
 *
 * @param {String} userGid - The user Gid.
 * @param {String} startDate - The period reference start date.
 * @param {String} endDate - The period reference end date.
 * @returns {Promise<Object>}
 */
async function getFlatRateWorkByGid(userGid: string, startDate: string, endDate: string) {
  return axios
    .get(`${flatRateWorkBaseUrl}/${userGid}?start_period=${startDate}&end_period=${endDate}`)
    .then((result) => {
      const user = utilsService.fromSnakeCaseToCamelCase(result.data);
      return user;
    });
}
